import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NewsImageUpload from "../last-news/NewsImageUpload";
import CloseButton from "./CloseButton";
import { handleCreatePartner } from "../../actions/partners";
import { uploadMedia } from "../../utils/api";

class AddPartnerModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  state = {
    title_ar: "",
    title_en: "",
    submitDisabled: true,
    files: [],
    imagePath: "",
    imageLoading: true,
  };

  handleSubmitDisabled = () => {
    const { title_ar, title_en, submitDisabled, imagePath } = this.state;
    if (!title_ar || !title_en || (!imagePath && !submitDisabled)) this.setState({ submitDisabled: true });
    if (title_ar && title_en && imagePath && submitDisabled) this.setState({ submitDisabled: false });
  };
  handleTitleArChange = (e) => {
    this.setState({ title_ar: e.target.value }, this.handleSubmitDisabled);
  };
  handleTitleEnChange = (e) => {
    this.setState({ title_en: e.target.value }, this.handleSubmitDisabled);
  };
  handleSetFiles = (files) => {
    this.setState(
      { files },
      () => {
        const { files } = this.state;
        const form = new FormData();
        form.append("file", files[0]);
        form.append("mime_type", "image");

        uploadMedia(form)
          .then((res) => res.json())
          .then((res) => {
            this.setState({ imagePath: res.path, imageLoading: false });
          });
      },
      this.handleSubmitDisabled
    );
  };

  handleSubmit = () => {
    const { createPartner, handleClose } = this.props;
    const { title_ar, title_en, imagePath } = this.state;
    const data = {
      title: {
        ar: title_ar,
        en: title_en,
      },
      image: imagePath,
    };
    createPartner(data);
    handleClose();
  };

  render() {
    const { open, handleClose } = this.props;
    const { title_ar, title_en, submitDisabled, files, imageLoading } = this.state;

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{
          paper: "dialog",
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <CloseButton handleClose={handleClose} />
        <DialogTitle id="responsive-dialog-title" className="text-center">
          إضافة شريك
        </DialogTitle>
        <DialogContent>
          <div className="form-group">
            <NewsImageUpload files={files} setFiles={this.handleSetFiles} loading={imageLoading} />
          </div>
          <div className="form-group">
            <TextField
              type="text"
              placeholder="اسم الشريك بالعربية"
              className="form-control"
              required
              value={title_ar}
              onChange={this.handleTitleArChange}
              variant="outlined"
              size="small"
            />
          </div>
          <div className="form-group">
            <TextField
              type="text"
              placeholder="اسم الشريك بالانجليزية"
              className="form-control"
              required
              value={title_en}
              onChange={this.handleTitleEnChange}
              variant="outlined"
              size="small"
            />
          </div>
        </DialogContent>
        <DialogActions className="justify-content-center align-items-center">
          <Button
            onClick={this.handleSubmit}
            color="primary"
            variant="contained"
            className="dialog__btn"
            disabled={submitDisabled}
          >
            حفظ
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  createPartner: (data) => dispatch(handleCreatePartner(data)),
});

export default connect(null, mapDispatchToProps)(AddPartnerModal);
